import * as React from 'react';

import AccessibleSVG from '../accessible-svg';

var IconFolderPersonal = function IconFolderPersonal(_ref) {
    var _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        _ref$height = _ref.height,
        height = _ref$height === undefined ? 32 : _ref$height,
        title = _ref.title,
        _ref$width = _ref.width,
        width = _ref$width === undefined ? 32 : _ref$width;
    return React.createElement(
        AccessibleSVG,
        {
            className: 'icon-folder-personal ' + className,
            title: title,
            width: width,
            height: height,
            viewBox: '0 0 32 32'
        },
        React.createElement('path', {
            fill: '#EFD289',
            d: 'M27,25H5c-0.6,0-1-0.4-1-1V8c0-0.6,0.4-1,1-1h8.6L16,9h11c0.6,0,1,0.4,1,1v14C28,24.6,27.6,25,27,25z'
        }),
        React.createElement('path', {
            fill: '#FDEFC1',
            d: 'M26.5,24h-21C5.2,24,5,23.8,5,23.5V12h22v11.6C27,23.8,26.8,24,26.5,24z'
        })
    );
};

IconFolderPersonal.propTypes = {
    className: PropTypes.string,
    height: PropTypes.number,

    /** A text-only string describing the icon if it's not purely decorative for accessibility */
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    width: PropTypes.number
};
export default IconFolderPersonal;
import PropTypes from 'prop-types';